import React from 'react';
import {
    Container, LogoContainer, Logo, UserNav, ProfileButton, UserIcon, ButtonContainer, Button
} from './Navbar.styles';
import { useHistory } from 'react-router-dom';
import { logout, useAuthorization, useAuthorizationDispatch } from 'core/context';
import { NODE_ENV } from 'core/utilities';

const Navbar : React.FunctionComponent = () =>
{
    const history = useHistory();
    const { isAuth } = useAuthorization();
    const dispatch = useAuthorizationDispatch();

    const onLogoClick = () => window.open(
        NODE_ENV === 'staging' ? 'https://demo.manzil.io' : 'https://manzil.ca', 
        '_blank');
    const onLogout = async () =>
    {
        await logout({ dispatch });
        history.push('/login');
    };

    const goToProfile = () =>
    {
        history.push('/profile');
    };

    return (
        <Container>
            <LogoContainer>
                <Logo onClick={onLogoClick} />
            </LogoContainer>
            <UserNav>
                {isAuth && (
                    <>
                        <ProfileButton onClick={goToProfile}><UserIcon /> My Account</ProfileButton>
                        <ButtonContainer onClick={onLogout}>
                            <Button>
                            Log Out
                            </Button>
                        </ButtonContainer>
                    </>
                )}
            </UserNav>
        </Container>
    );
};

export default Navbar;
